import "./index.css";
import VerifiedYes from "../../assets/verified_yes.png";

const AddIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M12 8h.01M11 12h1v4h1" />
    <circle cx="12" cy="12" r="9" />
  </svg>
);

const PlaceHolderifNothingAdded = ({
  text1,
  text2,
  text3,
  onClick,
  completed = false,
  pageIcon = "",
  cn = "",
}) => {
  const isInteractive = typeof onClick === "function";
  const state = completed ? "completed" : isInteractive ? "action" : "informational";
  const Panel = isInteractive ? "button" : "div";
  const accessibleLabel = [text1, text2].filter(Boolean).join(". ");

  return (
    <div className={`placeholder-wrapper placeholder-wrapper--${state} ${cn}`}>
      <Panel
        className="placeholder-card-panel"
        {...(isInteractive
          ? { type: "button", onClick, "aria-label": accessibleLabel }
          : { role: "status", "aria-label": accessibleLabel })}
      >
        <span
          className={`placeholder-icon ${completed || pageIcon ? "placeholder-icon--image" : ""}`}
          aria-hidden="true"
        >
          {completed ? (
            <img className="placeholder-completed-icon" src={VerifiedYes} alt="" />
          ) : pageIcon ? (
            <img className="placeholder-page-icon" src={pageIcon} alt="" />
          ) : isInteractive ? (
            <AddIcon />
          ) : (
            <InfoIcon />
          )}
        </span>

        <span className="placeholder-text">
          <span className="placeholder-title">{text1}</span>
          {text2 && <span className="placeholder-subtitle">{text2}</span>}
          {text3 && <span className="placeholder-subtitle">{text3}</span>}
        </span>
      </Panel>
    </div>
  );
};

export default PlaceHolderifNothingAdded;
